import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';

// BOOTSTRAP
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        domain={process.env.REACT_APP_DOMAIN}
        clientId={process.env.REACT_APP_CLIENTID}
        authorizationParams={{
            audience: process.env.REACT_APP_AUDIENCE,
            redirect_uri: window.location.origin,
            scope: process.env.REACT_APP_SCOPE,
        }}
    >
        <App />
    </Auth0Provider>,
);
